export const selectEquipmentRequirementsType = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-equipment-requirements-type.html'),
    controller: 'SelectEquipmentRequirementsTypeController'
};
